import { DecoratedUser } from '../types/user';

export const decorateUser = (user: DecoratedUser): DecoratedUser => {
  if (!user) {
    return user;
  }

  const decoratedUser: DecoratedUser = {
    ...user,
    hasPermissions: (perms: string | string[]): boolean => {
      if (!Array.isArray(perms)) {
        perms = [perms];
      }
      return perms.every(item => user.permissions?.includes(item) ?? false);
    },
    hasAccountFeature: (feature: string): boolean => {
      return (!!feature && user.accountFeatures?.includes(feature)) ?? false;
    },
    hasAccountFeatures: (features: string[]): boolean => {
      return !features || features.every(feature => user.accountFeatures?.includes(feature) ?? false);
    },
  };

  return {
    ...decoratedUser,
    canViewEmailConfig: (): boolean => {
      return decoratedUser.hasAccountFeature?.('TRIP_GROUP_EMAIL_CONFIGURATION') ?? false;
    },
    canIssueReports: (): boolean => {
      return decoratedUser.hasAccountFeature?.('TRIP_ASSIST_REPORTS') ?? false;
    },
    canManageIssues: (): boolean => {
      return decoratedUser.hasAccountFeature?.('TRIP_ASSIST') ?? false;
    },
    canViewTravelerMap: (): boolean => {
      return decoratedUser.hasAccountFeature?.('TRAVELER_MAP') ?? false;
    },
    canUseWaiverReports: (): boolean => {
      return decoratedUser.hasAccountFeature?.('WAIVER_REPORTING') ?? false;
    },
    canViewWaivers: (): boolean => {
      return (decoratedUser.hasAccountFeature?.('WAIVER_VIEW') || decoratedUser.hasAccountFeature?.('WAIVER_CREATE_EDIT')) ?? false;
    },
    isAccountAdmin: (): boolean => {
      return decoratedUser.hasPermissions?.(['account-admin']) ?? false;
    },
    isWaiverAdmin: (): boolean => {
      return decoratedUser.hasPermissions?.(['waiver-admin']) ?? false;
    },
    multiTabView: (): boolean => {
      return decoratedUser.accountFeatures?.length !== 1 || decoratedUser.accountFeatures[0] !== 'WAIVER_CREATE_EDIT';
    },
    showAdmin: (): boolean => {
      return decoratedUser.hasPermissions?.(['read-users', 'read-accounts', 'read-pages']) ?? false;
    },
    // Usage Reporting is available to Account Admins and Super Admins.
    canViewUsageReporting: (): boolean => {
      const isAccAdmin = decoratedUser.hasPermissions?.(['account-admin']) ?? false;
      const isSuperAdmin = decoratedUser.hasAccountFeature?.('SUPER_ADMIN') ?? false;
      return isAccAdmin || isSuperAdmin;
    },
    canViewTripStatusApi: (): boolean => {
      return decoratedUser.hasAccountFeature?.('API_ACCESS') ?? false;
    },
  };
};